import { useContext } from "react";
import { NetworkStatusContext } from "../context/NetworkStatusContext";

const NetworkMaintenanceOverlay = () => {
  const { offline, message, retry } = useContext(NetworkStatusContext);

  if (!offline) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-background/95 backdrop-blur-sm px-6 py-10">
      <div className="relative w-full max-w-xl overflow-hidden rounded-3xl border border-primary/20 bg-white/95 p-10 text-center shadow-2xl dark:bg-[#161616]/95">
        <div className="pointer-events-none absolute -top-32 -right-10 h-64 w-64 rounded-full bg-primary/30 blur-3xl dark:bg-primary/20" />
        <div className="pointer-events-none absolute -bottom-28 -left-16 h-60 w-60 rounded-full bg-main/20 blur-3xl dark:bg-main/10" />

        <div className="relative mx-auto mb-10 h-28 w-28">
          <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-primary/70 via-main/60 to-primary/50 shadow-xl shadow-primary/30" />
          <div className="absolute inset-[6px] rounded-[28px] bg-white/95 backdrop-blur-sm dark:bg-[#101010]/90" />
          <div className="absolute inset-0 flex items-center justify-center text-primary dark:text-main">
            <i className="bx bx-reset text-4xl" aria-hidden="true"></i>
          </div>
          <div className="pointer-events-none absolute -top-6 -right-4 h-16 w-16 rounded-full border border-main/20" />
          <div className="pointer-events-none absolute -bottom-4 -left-6 h-12 w-12 rounded-full border border-primary/20" />
        </div>

        <h1 className="relative text-3xl font-semibold text-text dark:text-[#f3f4f6]">
          Wir sind gleich wieder da
        </h1>
        <p className="relative mt-4 text-base leading-relaxed text-[#6b7280] dark:text-[#9ca3af]">
          Wir pflegen gerade ein Update ein, damit dein Dashboard reibungslos läuft.
        </p>
        {message && (
          <p className="relative mt-2 text-sm text-[#9ca3af] dark:text-[#6b7280]">
            {message}
          </p>
        )}

        <div className="relative mt-10 flex justify-center">
          <button
            type="button"
            onClick={retry}
            className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-primary to-main px-6 py-3 text-sm font-semibold uppercase tracking-widest text-white shadow-lg shadow-primary/20 transition-transform hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
          >
            Erneut verbinden
          </button>
        </div>
      </div>
    </div>
  );
};

export default NetworkMaintenanceOverlay;
